import { canAccess, PERMISSIONS } from './permissions';

export const selectGlobalResources = (
  authorization,
  { accounts, circularityDefaults },
) => {
  const resources = [];
  if (canAccess(authorization, PERMISSIONS.ACCOUNTS_SWITCH)) {
    resources.push(accounts());
  }
  if (
    circularityDefaults &&
    canAccess(authorization, PERMISSIONS.AUTOMATION_CONFIGURE)
  ) {
    resources.push(circularityDefaults());
  }
  return resources;
};
